<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!--title -->
      <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
        <h4 style="padding-left: 6px">{{ i18nValues["productionAdmin"] }}</h4>
        <el-button
          v-if="componentsMap.get('production_create')"
          icon="fas fa-plus"
          size="small"
          class="btn-primary"
          @click="add()"
        >
          {{ i18nValues["addProduction"] }}
        </el-button>
      </div>

      <!-- card body -->
      <div class="grid-body no-border borderBottom">
        <el-form>
          <div class="filters-wrapper">
            <div class="filters-row">
              <el-form-item :label="i18nValues['field']" prop="campo">
                <el-select
                  v-model="searchFilter.field"
                  value-key="id"
                  :placeholder="i18nValues['field']"
                  filterable
                  @change="changeFieldLots()"
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in FieldsList"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="i18nValues['batch']" prop="batch">
                <el-select
                  v-model="searchFilter.batch"
                  :placeholder="i18nValues['batch']"
                  filterable
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in FieldLotsList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- Event -->
              <el-form-item :label="i18nValues['detailedTrait']" prop="event">
                <el-select
                  v-model="searchFilter.event"
                  :placeholder="i18nValues['detailedTrait']"
                  filterable
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in eventsList"
                    :key="item.id"
                    :label="item.detailedTrait"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="i18nValues['experimentalCode']" prop="experimentalCode">
                <el-select
                  v-model="searchFilter.experimentalCode"
                  filterable
                  :placeholder="i18nValues['experimentalCode']"
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in ExperimentalCodeList"
                    :key="item.id"
                    :label="item.experimentalCode"
                    :value="item.experimentalCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Brand" prop="brand">
                <el-select
                  v-model="searchFilter.brand"
                  filterable
                  placeholder="Brand"
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in ProductList"
                    :key="item.id"
                    :label="item.brand"
                    :value="item.brand"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="i18nValues['status']" prop="status">
                <el-select
                  v-model="searchFilter.status"
                  :placeholder="i18nValues['status']"
                  filterable
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="i18nValues['realPlantingDate']" prop="realPlantingDate">
                <div class="input-group">
                  <el-date-picker
                    type="date"
                    class="calendar"
                    format="dd/MM/yyyy"
                    v-model="realPlantingDate"
                    :placeholder="i18nValues['realPlantingDate']"
                  >
                  </el-date-picker>
                  <span class="input-group-addon primary el-input__suffix icon">
                    <span class="arrow"></span>
                    <i class="fa fa-calendar-alt"></i>
                  </span>
                </div>
              </el-form-item>

              <!-- search button  -->
              <el-button
                @click="retrieveFilteredProductions()"
                icon="fas fa-search"
                id="searchButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["search"] }}
              </el-button>

              <!-- export button  -->
              <el-button
                @click="exportExcel()"
                icon="fas fa-file-excel"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["export"] }}
              </el-button>
            </div>
          </div>

          <!-- table and map container -->
          <div class="table-map-container">
            <!-- table -->
            <div class="table-wrapper table-container" v-loading="loading">
              <el-table
                :data="CropProducitonSubList"
                class="table table-hover"
                stripe
                style="width: 100%"
                id="CampaingsTable"
                :empty-text="hasAttemptedLoad ? i18nValues['noDataAvailable'] : ''"
                :default-sort="tableDefaultSort"
                @sort-change="handleSortChange"
              >
              <!-- FIELD -->
              <el-table-column
                prop="field.name"
                :label="i18nValues['field']"
                width="120"
                align="left"
                sortable
              ></el-table-column>

              <!-- BATCH -->
              <el-table-column
                prop="fieldLot.name"
                :label="i18nValues['batch']"
                width="100"
                align="left"
                sortable="custom"
              ></el-table-column>

              <!-- EVENT -->
              <el-table-column
                prop="product.event.detailedTrait"
                :label="i18nValues['detailedTrait']"
                width="180"
                align="left"
                sortable
              ></el-table-column>

              <!-- VARIETY -->
              <el-table-column
                prop="product.experimentalCode"
                :label="i18nValues['experimentalCode']"
                width="185"
                align="left"
                sortable
              ></el-table-column>

              <!-- BRAND -->
              <el-table-column
                prop="product.brand"
                label="Brand"
                width="100"
                align="left"
                sortable
              ></el-table-column>

              <!-- STATUS -->
              <el-table-column
                prop="status"
                :label="i18nValues['state']"
                width="110"
                align="left"
                sortable
              ></el-table-column>

              <!-- REAL PLANTING DATE -->
              <template>
                <el-table-column
                  prop="realPlanting"
                  :label="i18nValues['realPlantingDate']"
                  width="200"
                  align="left"
                  :formatter="formatDateRow"
                  sortable
                ></el-table-column>
              </template>

              <!-- EDIT/DELETE -->
              <el-table-column width="85" align="right" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    fixed="right"
                    class="text-info"
                    icon="fa fa-eye"
                    size="small"
                    :title="i18nValues['view']"
                    @click="view(scope.row.id)"
                  ></el-button>

                  <el-button
                    v-if="!isReadOnly() && componentsMap.get('production_modification')"
                    fixed="right"
                    class="text-info"
                    icon="fas fa-edit"
                    size="small"
                    :title="i18nValues['edit']"
                    @click="edit(scope.row.id)"
                  ></el-button>

                  <el-button
                    v-if="!isReadOnly()"
                    class="text-danger"
                    icon="fas fa-times"
                    size="small"
                    :title="i18nValues['remove']"
                    @click="deleteCropProduction(scope.row.id)"
                  ></el-button>
                </template>
              </el-table-column>
              </el-table>

              <div v-if="90 > 10" style="height: 15px"></div>
              <div class="pagination-bar">
                <PaginationFunctional
                  ref="pagination"
                  sublistName="CropProducitonSubList"
                  :fullList="CropProducitonList"
                  :tableSize="20"
                  :tableIndexInitial="initialPage"
                  @paginationChange="paginationChange"
                  @currentIndexPagination="setCurrentPage"
                  class="text-center"
                />
                <div v-if="CropProducitonList.length > 0" class="results-info">
                  <p>
                    {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
                  </p>
                </div>
              </div>
            </div>

            <!-- map on the right -->
            <div class="map-wrapper">
              <MapDashboard
                v-if="renderMap"
                :key="mapKey"
                :fields="fields"
                class="compact-map"
              />
            </div>
          </div>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue";
import MapDashboard from "@/components/dashboard/sections/MapDashboard.vue";
export default {
  name: "ProducitonsAdmin",

  components: {
    PaginationFunctional,
    MapDashboard,
  },

  computed: {
    loading: get("campaign/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),
    selectedLanguage: get("i18nStore/selectedLanguage"),

    statusOptions() {
      return [
        { value: "planned", label: this.i18nValues["planned"] },
        { value: "planted", label: this.i18nValues["planted"] },
        { value: "toHarvest", label: this.i18nValues["toHarvest"] },
        { value: "harvested", label: this.i18nValues["harvested"] },
        { value: "shipmentToPlant", label: this.i18nValues["shipmentToPlant"] },
        { value: "low", label: this.i18nValues["low"] },
      ];
    },

    // Pagination helpers for results label
    currentPage() {
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
        return this.$refs.pagination.tableIndex;
      }
      return this.initialPage || 1;
    },
    pageSize() {
      return 20; // Keep in sync with PaginationFunctional :tableSize
    },
    totalRecords() {
      if (Array.isArray(this.CropProducitonList)) {
        return this.CropProducitonList.length;
      }
      return typeof this.cantidad === "number" ? this.cantidad : 0;
    },
    startIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const start = (this.currentPage - 1) * this.pageSize + 1;
      return Math.min(start, this.totalRecords);
    },
    endIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },

    tableDefaultSort() {
      if (this.sortProp && this.sortOrder) {
        return { prop: this.sortProp, order: this.sortOrder };
      }
      return {};
    },
  },

  created() {
    this.restoreFromQuery();
    this.retrieveEvents();
    this.retrieveFields();
    this.retrieveProducts();
    this.retrieveCropProductionCount();
  },

  props: {
    componentsMap: {},
  },

  watch: {
    globalFieldSite: {
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        // Skip partial→full object update from TopBar
        if (oldVal && oldVal.id && oldVal.id === newVal.id) return;
        // Invalidate in-flight requests
        this.requestGeneration++;
        this.CropProducitonList = [];
        this.CropProducitonSubList = [];
        // Reset filters when fieldSite changes (not on first load)
        if (oldVal && oldVal.id) {
          this.searchFilter = {
            campaign: null, field: null, batch: null, event: null,
            variety: null, brand: null, status: null, realPlanting: null,
            experimentalCode: null,
          };
          this.realPlantingDate = null;
          this.initialPage = 1;
          this.sortProp = null;
          this.sortOrder = null;
        }
        // Only fetch if campaign is also available
        if (this.globalCampaign && this.globalCampaign.id) {
          this.fetchProductions(true);
          this.retrieveCropProductionCount();
        }
        this.syncRouteFromState();
      },
      immediate: true,
    },
    globalCampaign: {
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        if (oldVal && oldVal.id && oldVal.id === newVal.id) return;
        // Invalidate in-flight requests
        this.requestGeneration++;
        this.CropProducitonList = [];
        this.CropProducitonSubList = [];
        // Reset filters when campaign changes (not on first load)
        if (oldVal && oldVal.id) {
          this.searchFilter = {
            campaign: null, field: null, batch: null, event: null,
            variety: null, brand: null, status: null, realPlanting: null,
            experimentalCode: null,
          };
          this.realPlantingDate = null;
          this.initialPage = 1;
          this.sortProp = null;
          this.sortOrder = null;
        }
        this.hasAttemptedLoad = true;
        this.fetchProductions(true);
        this.retrieveCropProductionCount();
        this.retrieveProducts();
        this.syncRouteFromState();
      },
      immediate: true,
    },
    i18nValues: {
      handler() {
        // Re-translate if language changes
      },
      deep: true,
    },
  },

  data() {
    // Read route query NOW so immediate watchers don't overwrite it with defaults
    var q = (this.$route && this.$route.query) || {};
    var parsedEvent = q.event ? Number(q.event) : null;
    var parsedDate = q.realPlanting ? new Date(q.realPlanting) : null;
    if (parsedDate && isNaN(parsedDate.getTime())) parsedDate = null;
    return {
      renderMap: false,
      mapKey: 0,
      filter: this.globalCampaign ? this.globalCampaign.id : null,
      cantidad: 100,

      searchFilter: {
        campaign: null,
        field: q.field ? { id: null, name: q.field } : null,
        batch: q.batch || null,
        event: (parsedEvent !== null && !isNaN(parsedEvent)) ? parsedEvent : null,
        variety: null,
        brand: q.brand || null,
        status: q.status || null,
        realPlanting: null,
        experimentalCode: q.experimentalCode || null,
      },

      realPlantingDate: parsedDate,

      eventsList: [],

      CropProducitonList: [],
      CropProducitonSubList: [],

      fields: [],

      options: [],
      attributes: [
        "ac",
        "has",
        "qtyEstimateHarvest",
        "qtyRealHarvest",
        "realHarvest",
        "estimateHarvest",
        "realPlanting",
        "estimatePlanting",
        "status",
        "crop",
        "campaign",
        "measurementBatches",
        "field",
        "fieldLot",
        "fieldSite",
        "product",
        "qtyToHarvest",
        "qtyToPlant",
        "productionPerformanceEstimate",
        "bushel",
        "estimatedYield",
        "gm",
      ],
      columns: [],
      MeasurementsList: [],
      MeasurementsList2: [],
      FieldsList: [],
      FieldLotsList: [],
      ProductList: [],
      ExperimentalCodeList: [],
      initialPage: q.page ? Number(q.page) : 1,
      sortProp: q.sortProp || null,
      sortOrder: q.sortOrder || null,
      requestGeneration: 0,
      hasAttemptedLoad: false,
    };
  },
  methods: {
    getProps() {
      for (var i = 0; i < this.CropProducitonList.length; i++) {
        for (var key in this.CropProducitonList[i]) {
          if (
            key != "id" &&
            key != "date" &&
            key != "irrigation" &&
            key != "customer"
          ) {
            if (this.attributes.indexOf(key) == -1) {
              this.columns.push({ id: key, prop: key, name: key });
            }
          }
          //ELIMINA POSIBLES COLUMNAS REPETIDAS
          for (var j = 0; j < this.columns.length; j++) {
            for (var k = 0; k < this.columns.length; k++) {
              if (this.columns[j].id == this.columns[k].id && j != k) {
                this.columns.splice(k, 1);
              }
            }
          }
        }
      }
    },

    // ── Central fetch — called by watchers, search button, and delete ──
    fetchProductions(preservePage) {
      if (!this.globalCampaign || !this.globalCampaign.id) return;
      this.hasAttemptedLoad = true;
      var gen = ++this.requestGeneration;
      var campaignId = this.globalCampaign.id;

      // Determine if there are active filters
      var hasFilters = !!(this.searchFilter &&
        (this.searchFilter.field || this.searchFilter.batch ||
         this.searchFilter.event || this.searchFilter.experimentalCode ||
         this.searchFilter.brand || this.searchFilter.status ||
         this.realPlantingDate));

      var promise;
      if (hasFilters) {
        // Match field object to FieldsList if needed
        var field = this.searchFilter.field;
        if (field && typeof field === "object" && field.name && !field.id && this.FieldsList.length > 0) {
          var matchingField = this.FieldsList.find(function(f) { return f.name === field.name; });
          if (matchingField) {
            field = matchingField;
            this.searchFilter.field = matchingField;
            this.changeFieldLots();
          }
        }
        var modifiedSearchFilter = {
          field: field && typeof field === "object" ? field.name : field,
          batch: this.searchFilter.batch,
          event: this.searchFilter.event,
          experimentalCode: this.searchFilter.experimentalCode,
          brand: this.searchFilter.brand,
          status: this.searchFilter.status,
          campaign: campaignId,
          realPlanting: this.realPlantingDate != null ? this.extractDateOnly(this.realPlantingDate) : null,
        };
        promise = this.$store.dispatch("campaign/retrieveFilteredProductions", modifiedSearchFilter);
      } else {
        promise = this.$store.dispatch("campaign/retrieveCropProductions", campaignId);
      }

      promise.then((res) => {
        // ── Stale-response guard ──
        if (gen !== this.requestGeneration) return;

        this.CropProducitonList = res;
        this.renderFieldsMap(this.CropProducitonList);
        for (var i = 0; i < this.CropProducitonList.length; i++) {
          this.translate(this.CropProducitonList[i]);
        }

        // Apply sort BEFORE enriching with measurements
        if (this.sortProp && this.sortOrder) {
          var sorted = this.sortProductionsLocally(
            this.CropProducitonList, this.sortProp, this.sortOrder
          );
          if (Array.isArray(sorted)) {
            this.CropProducitonList = sorted;
          }
        }

        // Enrich with measurements AFTER sorting
        this.retrieveMeasurements();

        if (!preservePage) {
          this.initialPage = 1;
        }

        this.syncRouteFromState();

        // Sync pagination
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
            var targetPage = preservePage ? (this.initialPage || 1) : 1;
            this.$refs.pagination.currentChange(targetPage);
          }
        });
      });
    },

    // Aliases — existing callers (template @click, etc.) keep working
    search() {
      this.fetchProductions(true);
    },

    retrieveEvents() {
      this.$store.dispatch("event/retrieveEvents").then((res) => {
        this.eventsList = res;
      });
    },

    retrieveFields() {
      this.$store.dispatch("field/retrieveFields").then((res) => {
        this.FieldsList = res;
        // After FieldsList is loaded, try to match any field that was restored from query
        if (this.searchFilter.field && this.searchFilter.field.name && !this.searchFilter.field.id) {
          var matchingField = this.FieldsList.find(function(f) { return f.name === this.searchFilter.field.name; }.bind(this));
          if (matchingField) {
            this.searchFilter.field = matchingField;
            this.changeFieldLots();
          }
        }
      });
    },

    retrieveProducts() {
      var filter = {};
      filter.campaignId = this.globalCampaign ? this.globalCampaign.id : null;
      this.$store.dispatch("product/retrieveProducts", filter).then((res) => {
        this.ProductList = res;
        const filteredProducts = res.filter(
          (product) => product.experimentalCode !== null
        );
        // Create a unique list of experimental codes to avoid duplicates
        // This ensures the select can properly match selected values
        const uniqueCodes = new Set();
        this.ExperimentalCodeList = filteredProducts.filter((product) => {
          if (product.experimentalCode && !uniqueCodes.has(product.experimentalCode)) {
            uniqueCodes.add(product.experimentalCode);
            return true;
          }
          return false;
        });
      });
    },

    changeFieldLots() {
      this.FieldLotsList = [];
      this.searchFilter.fieldLot = null;
      for (var i = 0; i < this.FieldsList.length; i++) {
        if (this.searchFilter.field.id == this.FieldsList[i].id) {
          this.FieldLotsList = this.FieldsList[i].fieldLots;
        }
      }
    },

    add() {
      this.$router.push({
        name: `ProductionEdition`,
        params: {
          id: "0",
          idCampaign: this.globalCampaign ? this.globalCampaign.id : null,
        },
        query: this.$route.query,
      });
    },

    edit(id) {
      this.$router.push({
        name: `ProductionEdition`,
        params: {
          id: id,
          idCampaign: this.globalCampaign ? this.globalCampaign.id : null,
          mode: "edition",
        },
        query: this.$route.query,
      });
    },

    view(id) {
      this.$router.push({
        name: `ProductionEdition`,
        params: {
          id: id,
          idCampaign: this.globalCampaign ? this.globalCampaign.id : null,
          mode: "view",
        },
        query: this.$route.query,
      });
    },

    deleteCropProduction(id) {
      this.$confirm(
        "Está seguro que quiere eliminar la producción?",
        "Eliminar Producción",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.$store
          .dispatch("campaign/deleteCropProduction", id)
          .then((res) => {
            if (res.status == "OK") {
              this.$notify.success({
                title: this.i18nValues["success"],
                message: this.i18nValues["cropProductionDeleted"],
                position: "bottom-right",
              });
              this.fetchProductions(true);
              this.retrieveCropProductionCount();
            } else {
              this.$notify.error({
                title: this.i18nValues["error"],
                message: this.i18nValues["cantDeleteCropProduction"],
                position: "bottom-right",
              });
            }
          });
      });
    },

    formatEstimatePlanting(row) {
      return this.formatDate(row.estimatePlanting);
    },
    formatRealPlanting(row) {
      return this.formatDate(row.realPlanting);
    },
    formatEstimateHarvest(row) {
      return this.formatDate(row.estimateHarvest);
    },
    formatRealHarvest(row) {
      return this.formatDate(row.realHarvest);
    },

    retrieveMeasurements() {
      for (var i = 0; i < this.CropProducitonList.length; i++) {
        if (this.CropProducitonList[i].measurementBatches.length != 0) {
          this.CropProducitonList[i].measurementBatches.sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
          )[0];
          for (
            var j = 0;
            j <
            this.CropProducitonList[i].measurementBatches[0].dynamicVariables
              .length;
            j++
          ) {
            if (
              this.CropProducitonList[i].measurementBatches[0].dynamicVariables[
                j
              ].dynamicVariableDefinition.dataType == 0
            ) {
              this.CropProducitonList[i][
                this.CropProducitonList[
                  i
                ].measurementBatches[0].dynamicVariables[
                  j
                ].dynamicVariableDefinition.name
              ] = this.CropProducitonList[
                i
              ].measurementBatches[0].dynamicVariables[j].stringValue;
            }
            if (
              this.CropProducitonList[i].measurementBatches[0].dynamicVariables[
                j
              ].dynamicVariableDefinition.dataType == 1
            ) {
              this.CropProducitonList[i][
                this.CropProducitonList[
                  i
                ].measurementBatches[0].dynamicVariables[
                  j
                ].dynamicVariableDefinition.name
              ] = this.CropProducitonList[
                i
              ].measurementBatches[0].dynamicVariables[j].integerValues;
            }
            if (
              this.CropProducitonList[i].measurementBatches[0].dynamicVariables[
                j
              ].dynamicVariableDefinition.dataType == 2
            ) {
              this.CropProducitonList[i][
                this.CropProducitonList[
                  i
                ].measurementBatches[0].dynamicVariables[
                  j
                ].dynamicVariableDefinition.name
              ] = this.CropProducitonList[
                i
              ].measurementBatches[0].dynamicVariables[j].doubleValue;
            }
            if (
              this.CropProducitonList[i].measurementBatches[0].dynamicVariables[
                j
              ].dynamicVariableDefinition.dataType == 3
            ) {
              this.CropProducitonList[i][
                this.CropProducitonList[
                  i
                ].measurementBatches[0].dynamicVariables[
                  j
                ].dynamicVariableDefinition.name
              ] = this.CropProducitonList[
                i
              ].measurementBatches[0].dynamicVariables[j].longValue;
            }
          }
        }
      }
      this.getProps();
    },

    exportExcel() {
      let filter = {
        id: this.globalCampaign.id,
        selectedLanguage: this.selectedLanguage
      }
      this.$store
        .dispatch("campaign/exportExcelProductions", filter)
        .then((res) => {
          var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          const links = document.createElement("a");
          links.href = URL.createObjectURL(blob);
          links.download = (this.i18nValues["cropProductions"] || "Crop_Productions") + ".xlsx";
          links.click();
          URL.revokeObjectURL(links.href);
        });
    },

    retrieveFilteredProductions(preservePage) {
      this.fetchProductions(preservePage);
    },

    formatDateRow(row) {
      return this.formatDate(row.realPlanting);
    },

    extractDateOnly(dateString) {
      const datePart = dateString.toISOString().split("T")[0];
      return datePart;
    },

    translate(item) {
      if (item.status == "planned") {
        item.status = this.i18nValues["planned"];
      }
      if (item.status == "planted") {
        item.status = this.i18nValues["planted"];
      }
      if (item.status == "toHarvest") {
        item.status = this.i18nValues["toHarvest"];
      }
      if (item.status == "harvested") {
        item.status = this.i18nValues["harvested"];
      }
      if (item.status == "sowing") {
        item.status = this.i18nValues["sowing"];
      }
      if (item.status == "shipmentToPlant") {
        item.status = this.i18nValues["shipmentToPlant"];
      }
      if (item.status == "low") {
        item.status = this.i18nValues["low"];
      }
      if (item.status == "harvest") {
        item.status = this.i18nValues["harvest"];
      }
    },

    renderFieldsMap(cropProductions) {
      this.fields = [];
      if (cropProductions != null && cropProductions.length > 0) {
        var addedFieldIds = [];
        for (var i = 0; i < cropProductions.length; i++) {
          var field = cropProductions[i].field;
          var fieldId = cropProductions[i].field.id;

          if (addedFieldIds.indexOf(fieldId) === -1) {
            this.fields.push(field);
            addedFieldIds.push(fieldId);
          }
        }
      }
      this.renderMap = true;
      this.mapKey += 1;
    },

    handleSortChange(event) {
      var nextProp = event && event.prop ? event.prop : null;
      var nextOrder = event && event.order ? event.order : null;
      var sortChanged = this.sortProp !== nextProp || this.sortOrder !== nextOrder;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      if (!sortChanged) return;

      var sorted = this.sortProductionsLocally(
        this.CropProducitonList, this.sortProp, this.sortOrder
      );
      if (Array.isArray(sorted)) {
        this.CropProducitonList = sorted;
        var currentPage = this.$refs.pagination && this.$refs.pagination.tableIndex
          ? this.$refs.pagination.tableIndex : this.initialPage || 1;
        this.initialPage = currentPage;
        this.syncRouteFromState();
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
            this.$refs.pagination.currentChange(currentPage);
          }
        });
      }
    },

    sortProductionsLocally(list, prop, order) {
      if (!Array.isArray(list) || !prop || !order) {
        return list;
      }
      var direction = order === "descending" ? -1 : 1;
      var forceStringSort = prop === "fieldLot.name";
      var vm = this;
      var sorted = [].concat(list).sort(function(a, b) {
        var aVal = vm.getValueByPath(a, prop);
        var bVal = vm.getValueByPath(b, prop);
        if (vm.isEmptyValue(aVal) && vm.isEmptyValue(bVal)) return 0;
        if (vm.isEmptyValue(aVal)) return 1;
        if (vm.isEmptyValue(bVal)) return -1;
        if (!forceStringSort && vm.isNumericValue(aVal) && vm.isNumericValue(bVal)) {
          return (Number(aVal) - Number(bVal)) * direction;
        }
        var comparison = String(aVal).localeCompare(String(bVal), undefined, {
          sensitivity: "base",
          numeric: false,
        });
        return comparison * direction;
      });
      return sorted;
    },

    getValueByPath(item, path) {
      if (!item || !path) {
        return null;
      }
      return path.split(".").reduce((acc, segment) => {
        if (acc === null || acc === undefined) {
          return null;
        }
        return acc[segment];
      }, item);
    },

    isEmptyValue(value) {
      return value === null || value === undefined || value === "";
    },

    isNumericValue(value) {
      if (typeof value === "number") {
        return !isNaN(value);
      }
      if (typeof value === "string" && value.trim() === "") {
        return false;
      }
      return !isNaN(Number(value));
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.CropProducitonSubList = evt.list;
      }
      var currentIdx = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex : this.initialPage;
      this.initialPage = currentIdx || 1;
      this.syncRouteFromState();
    },

    setCurrentPage(idx) {
      if (typeof idx === "number") {
        this.initialPage = idx;
        this.syncRouteFromState();
      }
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      var q = this.$route.query || {};
      this.searchFilter = this.searchFilter || {};
      this.searchFilter.field = q.field ? { id: null, name: q.field } : null;
      this.searchFilter.batch = q.batch || null;
      if (q.event) {
        var eventNum = Number(q.event);
        this.searchFilter.event = !isNaN(eventNum) ? eventNum : null;
      } else {
        this.searchFilter.event = null;
      }
      this.searchFilter.experimentalCode = q.experimentalCode || null;
      this.searchFilter.brand = q.brand || null;
      this.searchFilter.status = q.status || null;
      this.realPlantingDate = q.realPlanting ? this.parseDate(q.realPlanting) : null;
      this.initialPage = q.page ? Number(q.page) : 1;
      this.sortProp = q.sortProp || null;
      this.sortOrder = q.sortOrder || null;

      // Match field object from FieldsList if available
      if (this.searchFilter.field && this.searchFilter.field.name) {
        this.$nextTick(() => {
          if (this.FieldsList.length > 0) {
            var matchingField = this.FieldsList.find(function(f) { return f.name === this.searchFilter.field.name; }.bind(this));
            if (matchingField) {
              this.searchFilter.field = matchingField;
              this.changeFieldLots();
            }
          }
        });
      }
    },

    syncRouteFromState() {
      var q = {};
      if (this.searchFilter) {
        if (this.searchFilter.field && typeof this.searchFilter.field === "object" && this.searchFilter.field.name) q.field = this.searchFilter.field.name;
        if (this.searchFilter.batch) q.batch = this.searchFilter.batch;
        if (this.searchFilter.event) q.event = String(this.searchFilter.event);
        if (this.searchFilter.experimentalCode) q.experimentalCode = this.searchFilter.experimentalCode;
        if (this.searchFilter.brand) q.brand = this.searchFilter.brand;
        if (this.searchFilter.status) q.status = this.searchFilter.status;
      }
      if (this.realPlantingDate) q.realPlanting = this.extractDateOnly(this.realPlantingDate);
      q.page = String(this.initialPage || 1);
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      if (this.globalFieldSite && this.globalFieldSite.id) q.fieldSiteId = String(this.globalFieldSite.id);
      if (this.globalCampaign && this.globalCampaign.id) q.campaignId = String(this.globalCampaign.id);

      var currentQ = this.$route.query || {};
      var keys = Object.keys(q);
      var isSame = keys.length === Object.keys(currentQ).length &&
        keys.every(function(k) { return String(q[k]) === String(currentQ[k]); });
      if (isSame) return;
      this.$router.replace({ query: q }).catch(function() {});
    },

    parseDate(s) {
      var dt = new Date(s);
      return isNaN(dt.getTime()) ? null : dt;
    },

    retrieveCropProductionCount() {
      if (!this.globalCampaign || !this.globalCampaign.id) return;
      var gen = this.requestGeneration;
      this.$store
        .dispatch("campaign/countCropProductions", { campaignId: this.globalCampaign.id })
        .then((res) => {
          if (gen !== this.requestGeneration) return;
          this.cantidad = res;
        });
    },
  },
};
</script>

<style scoped>
/* Filters wrapper - single horizontal line */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 1;
  min-width: 140px;
}

/* Make inputs narrower */
.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
  min-width: 120px;
  max-width: 100%;
}

/* Date picker slightly wider */
.filters-row /deep/ .el-date-editor {
  width: 150px;
  min-width: 130px;
  max-width: 100%;
}

/* Buttons in the same row, aligned to bottom */
.filters-row /deep/ .el-button {
  flex-shrink: 0;
  white-space: nowrap;
}

/* Table and Map side by side layout */
.table-map-container {
  display: flex;
  gap: 20px;
  margin: 0 auto;
  padding: 10px 20px;
  align-items: flex-start;
}

.table-wrapper {
  flex: 1;
  min-width: 0;
}

/* Table container with minimum height to prevent loading overlay jumping */
.table-container {
  min-height: 400px;
  position: relative;
}

/* Compress table to reduce scrolling */
#CampaingsTable /deep/ .el-table th,
#CampaingsTable /deep/ .el-table td {
  padding: 4px 8px !important;
  vertical-align: middle !important;
}

#CampaingsTable /deep/ .el-table .cell {
  padding: 0 !important;
  line-height: 1.3 !important;
  font-size: 11px !important;
}

#CampaingsTable /deep/ .el-table th {
  vertical-align: middle !important;
}

#CampaingsTable /deep/ .el-table th .cell {
  font-size: 11px !important;
  font-weight: 500 !important;
  display: flex !important;
  align-items: center !important;
}

.map-wrapper {
  flex: 0 0 350px;
  position: sticky;
  top: 20px;
}

.compact-map {
  width: 100%;
  height: 525px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive: stack on smaller screens */
@media (max-width: 1200px) {
  .table-map-container {
    flex-direction: column;
  }
  
  .map-wrapper {
    flex: 0 0 300px;
    width: 100%;
    position: static;
  }
  
  .compact-map {
    height: 300px;
  }
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
</style>
